import { APPLY_FORM_ROLES } from "../data/tribeRoles.js";

/** Primary inbox — FormSubmit activation link goes here first */
export const FORM_SUBMIT_EMAIL =
  import.meta.env.VITE_FORM_SUBMIT_EMAIL || "careers@origamicreative.com";

/** Also receive every application (FormSubmit _cc) */
export const FORM_SUBMIT_CC_LIST = ["the.bird@origamicreative.com"];

export const FORM_SUBMIT_CC =
  import.meta.env.VITE_FORM_SUBMIT_CC || FORM_SUBMIT_CC_LIST.join(", ");

export const FORM_SUBMIT_ALL = [FORM_SUBMIT_EMAIL, ...FORM_SUBMIT_CC_LIST];

export const FORM_SUBMIT_AJAX = `https://formsubmit.co/ajax/${FORM_SUBMIT_EMAIL}`;

/** Your WhatsApp Business number — country code, no + (e.g. 919876543210) */
export const WHATSAPP_PUBLIC = import.meta.env.VITE_WHATSAPP_PUBLIC || "";

export const WHATSAPP_GROUP_LINK = import.meta.env.VITE_WHATSAPP_GROUP_LINK || "";

/** Zapier / Make / n8n webhook — optional */
export const NOTIFY_WEBHOOK_URL = import.meta.env.VITE_NOTIFY_WEBHOOK_URL || "";

export const WHATSAPP_MESSAGES = {
  join: "Hi Alt Tribe — I'd like to learn about joining the tribe.",
  apply: "Hi Alt Tribe — I have a question about the freelancer application.",
  partner: "Hi Alt Tribe — I'd like to partner / brief the tribe on a project.",
};

export function getWhatsAppHref(message = WHATSAPP_MESSAGES.join) {
  if (!WHATSAPP_PUBLIC) return null;
  const num = WHATSAPP_PUBLIC.replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}

export const APPLY_ROLES = APPLY_FORM_ROLES;
